import { observer } from 'mobx-react-lite';
import { ListPage } from 'src/components/FormPages/ListPage';
import { SettingsDocumentationTemplatesStore } from 'src/stores/SettingsStores/SettingsDocumentationTemplatesStore/SettingsDocumentationTemplatesStore';
import styled from 'styled-components';

export const DocumentTemplateList = observer(() => {
    return (
        <StyledListPage
            pageName="setting-document-templates"
            store={SettingsDocumentationTemplatesStore}
            data-testid="setting-document-templates-list"
        />
    );
});

const StyledListPage = styled(ListPage)`
    .secondary-text {
        a {
            color: #6e6e73 !important;
            white-space: nowrap;
            &:hover {
                color: var(--form-text-color) !important;
            }

            &::after {
                content: ', ';
                margin-right: 0.4rem;
            }
            &:last-child::after {
                content: '';
                margin-right: 0;
            }
        }
    }
`;
